// extracted by mini-css-extract-plugin
module.exports = {"bazaarVoiceRating--rating_summary":"BazaarVoiceRating_bazaarVoiceRating--rating_summary__OVAZy"};